// Reviews API (V1 launch lane, 2026-10-01): in-app review request prompt.
// Backend contract: feat/in-app-review-requests (merged to main 4fcbd2c).
// All endpoints are JSON with the success envelope { success, data, error }.
import { api } from './api';

export type ReviewPromptReason =
  | 'not_tenured'
  | 'inactive_user'
  | 'already_submitted'
  | 'dismissed'
  | 'waiting'
  | 'eligible';

export interface ReviewPromptInfo {
  status?: string;
  remindAt?: string | null;
  lastShownAt?: string | null;
  shownCount?: number;
}

export interface ReviewPromptStatusData {
  eligible: boolean;
  reason: ReviewPromptReason;
  prompt?: ReviewPromptInfo | null;
}

export interface ReviewPromptResponse {
  success: boolean;
  error: string | null;
  data: ReviewPromptStatusData;
}

function payload<T = any>(res: any): T {
  return (res?.data?.data ?? res?.data) as T;
}

export const reviewsAPI = {
  /** GET /reviews/prompt-status — pure read, never mutates. */
  async promptStatus(): Promise<ReviewPromptStatusData> {
    const res = await api.get<ReviewPromptResponse>('/reviews/prompt-status');
    return payload<ReviewPromptStatusData>(res);
  },
  /** POST /reviews/prompt-shown — record the popup was shown (idempotent /24h). */
  async promptShown(): Promise<void> {
    await api.post('/reviews/prompt-shown');
  },
  /** POST /reviews/prompt-dismiss — { action: 'dismissed' | 'remind_later' }. */
  async promptDismiss(action: 'dismissed' | 'remind_later'): Promise<void> {
    await api.post('/reviews/prompt-dismiss', { action });
  },
  /** POST /reviews — submit { rating: 1..5, text? } → 201 pending; 409 if already submitted. */
  async submitReview(rating: number, text?: string): Promise<void> {
    const trimmed = (text || '').trim();
    await api.post('/reviews', { rating, ...(trimmed ? { text: trimmed } : {}) });
  },
};
